import React, { useContext, createContext } from 'react';
import useStoreConfig from './use';

const StoreConfigContext = createContext({});
const useStoreConfigContext = () => useContext(StoreConfigContext);

const StoreConfigContextProvider = ({ children }) => {
    const storeConfig = useStoreConfig();

    return (
        <StoreConfigContext.Provider value={storeConfig}>
            {children}
        </StoreConfigContext.Provider>
    );
};

export  { useStoreConfigContext };

export default StoreConfigContextProvider;
